import React from "react";
import "../styles/careers.css";

const Careers = () => {
  return (
    <div className="careers-container">
    
      <div className="careers-card">
        <h2>📄 Join Our Team</h2>
        <p>
          Drop your resume directly to our recruitment email:{" "}
          <a href="mailto:careers@neelaverse.com">careers@neelaverse.com</a>
        </p>
        <p>
          For any queries regarding the application process, contact: <strong>+91-8121956868</strong>
        </p>
      </div>
    </div>
  );
};

export default Careers;
